export default __webpack_public_path__ + "static/media/bus.8cc574c9.svg";